import _createClass from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
// Taken from https://stackoverflow.com/a/41429145/2247097
export var ClientNotInitializedError = /*#__PURE__*/function (_Error) {
  _inherits(ClientNotInitializedError, _Error);

  var _super = _createSuper(ClientNotInitializedError);

  function ClientNotInitializedError() {
    var _this;

    _classCallCheck(this, ClientNotInitializedError);

    _this = _super.call(this); // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_this), ClientNotInitializedError.prototype);
    return _this;
  }

  return _createClass(ClientNotInitializedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var QRCodeModalError = /*#__PURE__*/function (_Error2) {
  _inherits(QRCodeModalError, _Error2);

  var _super2 = _createSuper(QRCodeModalError);

  function QRCodeModalError() {
    var _this2;

    _classCallCheck(this, QRCodeModalError);

    _this2 = _super2.call(this); // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_this2), QRCodeModalError.prototype);
    return _this2;
  }

  return _createClass(QRCodeModalError);
}( /*#__PURE__*/_wrapNativeSuper(Error));